// removed by extract-text-webpack-plugin
module.exports = {"alert":"alert__alert-3eiyN","alertTitle":"alert__alertTitle-3uy9S","alertDescription":"alert__alertDescription--GzUr","link":"alert__link-1sbIg","image":"alert__image-25QI2","success":"alert__success-1NFz7","fail":"alert__fail-16zyb","redirect":"alert__redirect-3MYNH"};


//////////////////
// WEBPACK FOOTER
// ./components/payment/alert/alert.css
// module id = 850
// module chunks = 0